import React, { useEffect, useState } from "react";
import AgentHeader from "../../components/agent-ui/AgentHeader";
import "./dev.css";
import { Btn } from "../../utils/utils";
import HouseCard from "../../components/ui/HouseCard";
import { useNavigate } from "react-router-dom";
import { AxiosAuthGet } from "../../api/api";
import Loading from "../../components/ui/Loading";
import useEstates from "../../hooks/useEstates";
import Pagination from "../../utils/pagination";

const DevProperty = () => {
  // ?search=%20jbugug&page=4&page_size=6
  const [searchProp, setSearchProp] = useState("");
  const [curPage, setCurPage] = useState(1);
  const getUrl = `developer/properties/?search=${searchProp}&page=${curPage}&page_size=12`;
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [activeEst, setActiveEst] = useState("");
  const estUrl = `developer/estates/${activeEst}/properties/?search=${searchProp}&page=${curPage}&page_size=5`
  const [propArr, setPropArr] = useState([]);
  const [pag, setPag] = useState();
  const { estatesArr } = useEstates();

  const clickEstate = (item) => {
    if(activeEst === item?.id){
      setActiveEst("");
    } else{
      setActiveEst(item?.id);
    }
  };
  const seeMore = () => {
    navigate("/dev_dash/estate/estate-view/");
  };
  const viewProp = (item) => {
    localStorage.setItem('singleProp', JSON.stringify(item));
    navigate("/dev_dash/property/single-view/");
  };
  const addEst = () => {
    navigate("/dev_dash/estate/estate-add/");
  };
  const addProp = () => {
    localStorage.removeItem("editProp");
    navigate("/dev_dash/property/property-add/");
  };

  const getProp = () => {
    setIsLoading(true);
    AxiosAuthGet(getUrl)
      .then((res) => {
        // console.log(res);
        setPropArr(res.data);
        setPag(res.pagination);
        setIsLoading(false);
      })
      .catch((err) => {
        // console.log(err.response);
        setIsLoading(false);
      });
  };
  const getPropByEst = () => {
    setIsLoading(true);
    AxiosAuthGet(estUrl)
      .then((res) => {
        // console.log(res);
        setPropArr(res.data);
        setPag(res.pagination);
        setIsLoading(false);
      })
      .catch((err) => {
        // console.log(err.response);
        setIsLoading(false);
      });
  };

  const clickNext = () => {
    setCurPage(pag?.nextPage);
  };
  const clickPrev = () => {
    setCurPage(pag?.previousPage);
  };

  useEffect(() => {
    if(activeEst !== ""){
      getPropByEst()
    } else {
      getProp();
    }
    // eslint-disable-next-line
  }, [searchProp, curPage, activeEst]);

  return (
    <>
      {/* {isLoading && <Loading />} */}

      <div>
        <AgentHeader
          header={"Properties"}
          btnText={"Add Property"}
          placeholder={"Search for property"}
          isSearch
          btnClick={addProp}
          btnClick2={addEst}
          btnText2={"Add Estate"}
          changeInput={(e) => {
            setSearchProp(e.target.value);
          }}
        />
        {estatesArr?.length !== 0 && <div className="estate_list_cont">
          {estatesArr?.slice(0, 5).map((item, idx) => {
            return (
              <div key={idx} className="es_btn">
                <Btn
                  btnText={item?.name}
                  btnClick={() => clickEstate(item)}
                  btnClass={`min_wid ${
                    activeEst === item?.id ? "btn_small" : "btn_trans_small"
                  }`}
                />
              </div>
            );
          })}
          <p onClick={seeMore} style={{ minWidth: 60 }}>
            See more
          </p>
        </div>}
        {isLoading ? <Loading /> : (
          <div className="estates_houses dev_prop_co">
            {propArr.length === 0 ? <p className="emp_p">Nothing to show here</p> : propArr.map((item, idx) => {
              return (
                <HouseCard
                  key={idx}
                  tag={item?.isVerified}
                  price={`#${item?.pricePerUnit?.toLocaleString()}` }
                  add={item.address}
                  // bath={item.bath}
                  // bed={item.bed}
                  propType={item?.propertyType}
                  noOfUnits={item?.numberOfUnits}
                  title={item?.name}
                  btnClick={() => viewProp(item)}
                  img={item?.pictures[0]?.link}
                  houseStyle={{width: '22%'}}
                />
              );
            })}

          </div>
        )}
        {pag && (
          <Pagination
            clickNext={clickNext}
            clickPrev={clickPrev}
            pagData={pag}
          />
        )}
      </div>
    </>
  );
};

export default DevProperty;
